<div class="input-container focus-rect" [class.red]="invalid">
  <label [for]="id" [class.red]="invalid" [innerHtml]="textLabelName | translate"></label>
  <select [id]="id" (input)="onValueChange($event)" (change)="onValueChange($event)" (blur)="onTouch()">
    <option *ngFor="let item of items; let i=index;" [ngValue]="i" [selected]="i === val">{{item}}</option>
  </select>
</div>
<div *ngIf="invalid" class="errmsg">{{errormessage | translate }}</div>
